export const CONFIRMATION_MODAL_MIN_HEIGHT = 'calc(60vh - 96px)';
export const CLP_CONTAINER_MAX_WIDTH = '778px';
